import { StateConfig } from 'components/charts/config'
import { SwitchElement } from '../component/switch-sections/interface'
export type ChartIntervalTypes = '1 month' | '3 months' | '1 year' | 'All time'

export type ProductActionType = TimeIntervalQueryAction | SelectedProductPreviewAction

export type TimeIntervalQueryAction = {
  type: 'set_chart_time_window'
  payload: StateConfig
}

export type SelectedProductPreviewAction = {
  type: 'set_selected_product_preview'
  payload: SwitchElement
}

export const ProductPreviewSwitchMenu = [
  SwitchElement.PERFORMANCE,
  SwitchElement.ASSET_ALLOCATION,
  SwitchElement.ADDITIONAL_INFO,
  SwitchElement.FAQ,
]
